import RoutesMap from 'route_control/RouteControl'
import { FolderList, FileList, Document } from 'pages/documents'

const DocumentsRoute = () => {
    return [
        {
            path: RoutesMap.FOLDER_LIST.path,
            element: <FolderList />,
        },
        {
            path: RoutesMap.FILES_LIST.path,
            element: <FileList />,
        },
        {
            path: RoutesMap.DOCUMENT.path,
            element: <Document />,
        },
    ]
}

export default DocumentsRoute;